<template>
  <div class="col-md-8 offset-md-2">
    <h2 class="text-center">Данные для оформления заказа</h2>
    <hr>

    <div class="form-group row">
      <label for="payment" class="col-sm-4 col-form-label">Cпособ оплаты</label>
      <div class="col-sm-8">
        <select class="form-control" id="payment" v-model="paymentType">
          <option selected="selected">Нажмите что бы выбрать...</option>
          <option v-for="pay in state.payments" :value="pay">{{ pay.name }}</option>
        </select>
      </div>
    </div>

    <div class="form-group row">
      <label for="payment" class="col-sm-4 col-form-label">Cпособ получения</label>
      <div class="col-sm-8">
        <select class="form-control" id="payment" v-model="deliverys">
          <option selected="selected">Нажмите что бы выбрать...</option>
          <option value="shippings" v-if="state.shippings.length > 0">Доставка</option>
          <option value="pickups" v-if="state.pickups.length > 0">Самовывоз</option>
        </select>
      </div>
    </div>

    <div class="form-group row" v-if="state.deliverys == 'shippings'">
      <label for="payment" class="col-sm-4 col-form-label">Категория доставки</label>
      <div class="col-sm-8">
        <select class="form-control" id="payment" v-model="shipping" v-on:change="changeDelivery(shipping)">
          <option selected="selected">Нажмите что бы выбрать...</option>
          <option :value="shipping" v-for="shipping in state.shippings">{{ shipping.name }}
            <span v-if="shipping.sale">(-{{ shipping.sale }} %)</span>
            <span v-if="shipping.margin">(+{{ shipping.margin }} руб.)</span>
            <span v-if="shipping.min_price">(мин. сумма {{ shipping.min_price }} руб.)</span>
          </option>
        </select>
      </div>
    </div>

    <div class="form-group row" v-if="state.deliverys == 'pickups'">
      <label for="payment" class="col-sm-4 col-form-label">Точка самовывоза</label>
      <div class="col-sm-8">
        <select class="form-control" id="payment" v-model="pickup" v-on:change="changeDelivery(pickup)">
          <option selected="selected">Нажмите что бы выбрать...</option>
          <option :value="pickup" v-for="pickup in state.pickups">{{ pickup.name }}
            <span v-if="pickup.sale">(-{{pickup.sale}} %)</span>
            <span v-if="pickup.margin">(+{{pickup.margin}} руб.)</span>
            <span v-if="pickup.min_price">(мин. сумма {{pickup.min_price}} руб.)</span>
          </option>
        </select>
      </div>
    </div>

    <div class="col-md-12" v-if="descrDelivery" style="padding: 10px 20px; margin: 20px 0; border-radius:15px; background-color: #dff0d8;">
      <div>
        <h3>Описание условий <span v-if="state.deliverys == 'shippings'">доставки</span><span v-if="state.deliverys == 'pickups'">самовывоза</span></h3>
        <p class="text-left">{{ descrDelivery }}</p>
      </div>
    </div>



    <div class="form-group row">
      <label for="name" class="col-sm-4 col-form-label">Имя</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" id="name" placeholder="Введите имя" v-model="name">
      </div>
    </div>

    <div class="form-group row">
      <label for="phone" class="col-sm-4 col-form-label">Телефон</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" id="phone" placeholder="Введите номер телефона" v-model="phone">
      </div>
    </div>

    <div class="form-group row" v-if="state.deliverys == 'shippings'">
      <label for="adres" class="col-sm-4 col-form-label">Адрес доставки</label>
      <div class="col-sm-8">
        <input type="text" class="form-control" v-model="deliveryAdres" id="adres" placeholder="Введите адрес доставки">
      </div>
    </div>

    <div class="form-group row">
      <label for="comment" class="col-sm-4 col-form-label">Коментарий</label>
      <div class="col-sm-8">
        <textarea class="form-control" id="comment" placeholder="Введите комментарий к заказу" v-model="comment"></textarea>
      </div>
    </div>

    <div class="col-md-6 offset-md-3">
      <button class="btn-lg btn-block btn-buy" @click="checkPayment()">Оформить заказ</button>
    </div>

  </div>
</template>

<script>
  import axios from 'axios'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.min.css'

  export default {
    data: function () {
      return {
        shipping: '',
        pickup: '',
        paymentType: '',
        deliveryAdres: '',
        name: '',
        phone: '',
        comment: '',
        descrDelivery: '',
        disabled: 'false',
      }
    },
    computed: {
      config() {
        return this.$store.state.config;
      },
      state() {
        return this.$store.state;
      },
      cart() {
        return this.$store.state.cart;
      },
      total_in_cart() {
        return _.sumBy(this.cart, function (product) {
          return product.price * product.qty;
        });
      },
      total_price() {
        var vm = this;
        var price = vm.total_in_cart;
        if (vm.orderProp.sale) {
          if (vm.orderProp.sale == 0) {
            return price;
          } else {
            return price - (price / 100 * vm.orderProp.sale);
          }
        } else if (vm.orderProp.margin) {
          return parseInt(price, 10) + parseInt(vm.orderProp.margin.margin, 10);
        } else {
          return price;
        }
      },
      deliverys: {
        get() {
          return this.$store.state.deliverys;
        },
        set(data) {
          this.descrDelivery = '';
          this.defaultTypes(null, null, null);
          this.$store.commit({
            type: 'deliverys',
            data
          });
        }
      },
      orderProp() {
        return this.$store.state.orderProp;
      },
    },
    created() {
      this.defaultTypes(null, null, null);
    },
    methods: {
      defaultTypes(margin, min_price, sale) {
        var props = {
          sale: sale,
          margin: margin,
          min_price: min_price
        }
        this.$store.commit({
          type: 'updateOrderProp',
          props
        });
      },
      changeDelivery: function changeItem(value) {

        if (value) {
          this.descrDelivery = value.descr;

          if (value.margin) {
            this.defaultTypes(value, null, null);
          } else if (value.min_price) {
            this.defaultTypes(null, value.min_price, null);
          } else if (value.sale) {
            this.defaultTypes(null, null, value.sale);
          }

        }

      },
      checkPayment() {
        var vm = this;

        if (this.disabled == 'false') {
          if (vm.paymentType.id) {
            vm.checkDelivery();
          } else {
            swal({
              title: "Ошибка",
              text: "Выберите способ оплаты.",
              type: "warning",
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "ОК!"
            });
          }
        } else {
          swal({
            title: "Ошибка",
            text: "Подождите, идет выполнение операции.",
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "ОК!"
          });
        }
      },
      checkDelivery() {
        var vm = this;
        if (vm.deliverys == 'shippings') {

          if (vm.shipping) {

            if (vm.orderProp.min_price != null && vm.orderProp.min_price > vm.total_in_cart) {
              swal({
                title: "Ошибка",
                text: 'Сумма заказа должна привышать ' + vm.orderProp.min_price + ' руб.',
                type: "warning",
                showCancelButton: false,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "ОК!"
              });
            } else {
              vm.checkDeliveryAdress();
            }

          } else {
            swal({
              title: "Ошибка",
              text: 'Выберите категорию доставки',
              type: "warning",
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "ОК!"
            });
          }

        } else if (vm.deliverys == 'pickups') {

          if (vm.pickup) {

            if (vm.orderProp.min_price != null && vm.orderProp.min_price > vm.total_in_cart) {
              swal({
                title: "Ошибка",
                text: 'Сумма заказа должна привышать ' + vm.orderProp.min_price + ' руб.',
                type: "warning",
                showCancelButton: false,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "ОК!"
              });
            } else {
              vm.checkNamePhone();
            }

          } else {
            swal({
              title: "Ошибка",
              text: "Выберите точку самовывоза",
              type: "warning",
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "ОК!"
            });
          }

        } else {
          swal({
            title: "Ошибка",
            text: "Выберите способ получения товара",
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "ОК!"
          });
        }

      },
      checkDeliveryAdress() {
        var vm = this;

        if (vm.deliveryAdres) {
          vm.checkNamePhone();
        } else {
          swal({
            title: "Ошибка",
            text: "Вы не ввели адрес доставки",
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "ОК!"
          });
        }

      },
      checkNamePhone() {
        var vm = this;

        if (!vm.name) {
          swal({
            title: "Ошибка",
            text: 'Вы не ввели имя',
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "ОК!"
          });
        } else if (!vm.phone) {
          swal({
            title: "Ошибка",
            text: 'Вы не ввели номер телефона',
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "ОК!"
          });
        } else if (vm.phone && vm.name) {
          vm.sendOrder();
        }

      },
      sendOrder() {
        var vm = this;

        var device = 'site';

        if (vm.deliverys == "shippings") {
          var del = {
            id: vm.shipping.id,
            type: 'Доставка',
            adres: vm.deliveryAdres,
          };
        } else if (vm.deliverys == "pickups") {
          var del = {
            id: vm.pickup.id,
            type: 'Самовывоз',
          };
        }

        var data = {
          payment: vm.paymentType.name,
          delivery: del,
          name: vm.name,
          phone: vm.phone,
          comment: vm.comment,
          device: device,
          price: vm.total_price,
          cart: vm.cart,
        };

        vm.disabled = true;

        axios.get(vm.config.url + vm.config.get_api + vm.config.id).then(
          res => {

            var tokens = {
              'headers': {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + res.data,
              }
            }

            axios.post(vm.config.url + vm.config.api_url + vm.config.id + vm.config.orders, data, tokens).then(
              function (response) {
                swal({
                  title: "Отлично!",
                  text: "Заказ успешно отправлен, скоро наш оператор свяжется с Вами.",
                  type: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: "ОК!"
                });
                vm.$store.commit('updateCart');
                vm.disabled = false;
              })

          });


      }
    },
  }

</script>



// WEBPACK FOOTER //
// src/components/Order/form.vue